<div class="colored-hint" [ngClass]="type" [class.inline]="inline">
  <ng-content> </ng-content>
</div>
